/* `replacement` keeps block tags from running words together: stripTags("<p>One.</p><p>Two.</p>", " ")
   gives "One. Two. " instead of "One.Two." - collapse the whitespace at the call site. */
export const stripTags = (value: string, replacement = "") => {
  const RE_HTML_TAGS = /(<!--.*?-->|<[^>]*>)/g;
  return value.replace(RE_HTML_TAGS, replacement);
};
